export function padNumber(num: number): string {
  return num.toString().padStart(2, "0");
}

export function parseBackendDate(datePost: string | Date): Date {
  if (datePost instanceof Date) {
    return datePost;
  }

  const trimmed = datePost.trim();
  if (!trimmed) {
    return new Date(NaN);
  }

  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(trimmed)) {
    return new Date(trimmed);
  }

  const normalized = trimmed.includes(" ")
    ? trimmed.replace(" ", "T")
    : trimmed;

  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(normalized)) {
    return new Date(`${normalized}Z`);
  }

  return new Date(trimmed);
}

const pluralize = (value: number, unit: string) =>
  `${value} ${unit}${value === 1 ? "" : "s"} ago`;

export function getTimeAgo(datePost: string | Date): string {
  const currentDate = new Date();
  const postDate = parseBackendDate(datePost);

  if (Number.isNaN(postDate.getTime())) {
    return "";
  }

  const seconds = Math.floor(
    (currentDate.getTime() - postDate.getTime()) / 1000
  );

  if (seconds < 0) {
    return "Just now";
  }
  if (seconds < 60) {
    return seconds <= 5 ? "Just now" : pluralize(seconds, "second");
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return pluralize(minutes, "minute");
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return pluralize(hours, "hour");
  }

  const days = Math.floor(hours / 24);
  if (days < 30) {
    return pluralize(days, "day");
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    return pluralize(months, "month");
  }

  return pluralize(Math.floor(months / 12), "year");
}

export function getDate(date: string | Date | undefined) {
  if (typeof date === "string") {
    let normalized = date;
    if (date.includes("/")) {
      const [year, month, day] = date.split("/");
      normalized = `${year}-${month}-${day}`;
    }
    return new Date(normalized).toLocaleDateString();
  }
  return date?.toLocaleDateString();
}

export function getAge(date: string | Date | undefined) {
  const birthDate = new Date(date as string | Date);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasNotHadBirthday =
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() < birthDate.getDate());
  if (hasNotHadBirthday) {
    age--;
  }
  return age;
}

export function getDateObject(date: string) {
  let normalized = date;
  if (date.includes("/")) {
    const [year, month, day] = date.split("/");
    normalized = `${year}-${month}-${day}`;
  }
  return new Date(normalized);
}
